import { ChangeDetectionStrategy, Component, inject, signal } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LanguageSwitcherComponent } from "@shared-core/general/queue/components/language-switcher/language-switcher.component";
import { QueueLayoutAbstraction } from "@shared-core/general/queue/abstractions/queue-layout.abstraction";

@Component({
  selector: "app-queue-header",
  standalone: true,
  imports: [TranslateModule, LanguageSwitcherComponent],
  templateUrl: "./queue-header.component.html",
  styleUrl: "./queue-header.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueueHeaderComponent {
  // Optional: the header also renders in layouts that don't provide the queue
  // layout abstraction (e.g. the guest/auth layout), where there's no
  // fullscreen affordance — fall back to an empty signal so the button hides.
  private readonly queueLayout = inject(QueueLayoutAbstraction, { optional: true });

  /** Fullscreen toggle contributed by the active page; absent on most pages. */
  readonly fullscreenToggle = this.queueLayout?.fullscreenToggle ?? signal<(() => void) | null>(null);
}
